import { type ReactNode } from 'react'
import { ErrorBoundary } from '@mc/error-boundary'
import Experiment from '@mc/experiments-react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { CardPricingLine } from 'pages/classes/[slug]/components/Hero/CardPricingLine'
import ShieldCheckIcon from '../assets/shield-check.svg'
import { EXPERIMENT_FLAG } from '../constants'
import { useExperimentCriteria } from '../hooks/useExperimentCriteria'
import { EXPERIMENT_I18N_NAMESPACE, i18nInstance } from '../i18n'

// variant_1, variant_3
const GuaranteeCallout = withI18nContext(i18nInstance)(() => {
  const { t } = useTranslation(EXPERIMENT_I18N_NAMESPACE)

  return (
    <p className='d-flex flex-wrap align-items-center justify-content-center mc-column-gap-1 mc-text-small mc-mt-1'>
      <span className='d-flex align-items-center mc-column-gap-2 mc-text--nowrap'>
        <ShieldCheckIcon aria-hidden='true' width={16} height={16} />
        <span>{t('guaranteeCallout.title')}</span>
      </span>
      <span className='mc-opacity--muted mc-text--nowrap'>
        {t('guaranteeCallout.subtitle')}
      </span>
    </p>
  )
})

// variant_1, variant_3
const PricingWithGuaranteeCallout = () => (
  <>
    <CardPricingLine hideMoneyBackGuarantee />
    <GuaranteeCallout />
  </>
)

export const PricingLineWrapper = ({ control }: { control: ReactNode }) => {
  const isEligible = useExperimentCriteria()

  if (!isEligible) return <ErrorBoundary>{control}</ErrorBoundary>

  return (
    <Experiment
      name={EXPERIMENT_FLAG}
      track={false}
      default={() => control}
      variant_1={() => <PricingWithGuaranteeCallout />}
      variant_2={() => control}
      variant_3={() => <PricingWithGuaranteeCallout />}
    />
  )
}
